// extracted by mini-css-extract-plugin
export var cancelButton = "_nm-5";
export var content = "_nm-3";
export var createButton = "_nm-6";
export var drawerContainer = "_nm-0";
export var footer = "_nm-2";
export var header = "_nm-1";
export var orderFormColumn = "_nm-4";